import header from './components/header';
import modal from "./components/modal";
import cookie from "./components/cookie";
import slider from "./components/slider";
import scrollTrig from "./components/scrolltriger-about";
import tab from "./components/tab";
import diagrams from "./components/hover-diagrams";
import map from "./components/map";
import hoverFooter from "./components/hover-footer";
import formFile from "./components/form-file";
import filter from "./components/filter";
import video from "./components/video-play";
import loadmore from "./components/loadmore";
import filterTable from "./components/filter-table";
// import validateJs from './components/validate-form';
// import conterUp from "./imports/contUp";

export default () => {
    header();
    modal();
    cookie();
    slider();
    scrollTrig();
    tab();
    diagrams();
    map();
    hoverFooter();
    formFile();
    filter();
    video();
    loadmore();
    filterTable();
    // validateJs();
}
